import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Whatsapp({ color, fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 16 16' {...props}>
      <Path
        d='
          M12.9605 3.03468
          C11.6445 1.7236 9.89441 1.0008 8.02998 1
          C4.1868 1 1.05996 4.11173 1.05916 7.93671
          C1.05756 9.15386 1.37816 10.3503 1.98898 11.4051
          L1 15
          L4.69528 14.0352
          C5.71783 14.5892 6.86271 14.8798 8.02678 14.8798
          H8.02998
          C11.8716 14.8798 14.9984 11.7673 15 7.94229
          C15.0008 6.0891 14.2765 4.34656 12.9605 3.03468Z
        '
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill-rule='evenodd'
        clip-rule='evenodd'
      />
      <Path
        d='
          M8.875 9.25242
          L9.19969 8.93013
          C9.49799 8.63423 9.96982 8.59664 10.3137 8.83816
          C10.6464 9.07168 10.9471 9.28121 11.227 9.47634
          C11.6716 9.78503 11.7252 10.4184 11.3422 10.8007
          L11.0551 11.0878
        '
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='
          M4.91406 4.94879
          L5.20116 4.66169
          C5.58343 4.27942 6.21682 4.333 6.52551 4.77685
          C6.71984 5.05675 6.92937 5.35745 7.16369 5.69014
          C7.40521 6.03402 7.36842 6.50586 7.07172 6.80415
          L6.74943 7.12884
        '
        stroke={color}
        fill='transparent'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='
          M11.0511 11.09
          C9.86667 12.2688 7.87615 11.2676 6.30469 9.69531
        '
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='
          M6.30824 9.6995
          C4.73677 8.12724 3.73552 6.13752 4.91431 4.95312
        '
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='
          M6.75781 7.125
          C7.01293 7.52726 7.34001 7.92553 7.70949 8.295
          L7.71109 8.2966C8.08056 8.66607 8.47882 8.99316 8.88108 9.24827
        '
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Whatsapp.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Whatsapp
